<template>
  <v-form ref="form" :readonly="readonly">
    <v-row>
      <!-- Modo criação/edição -->
      <template v-if="!readonly && economic_group_credit">
        <v-col cols='12'>
          <v-text-field 
            v-model="economic_group_credit.limit_aux" 
            v-money="money"
            :rules="required"
            label="Limite de Crédito (R$)" 
            prepend-icon="mdi-cash-multiple"
            prefix="R$"
          ></v-text-field>
        </v-col>
        <v-col cols='12'>
          <v-text-field 
            v-model="economic_group_credit.blockingTime" 
            :rules="required"
            label="Tempo para Bloqueio"
            prepend-icon="mdi-calendar-clock"
          ></v-text-field>
        </v-col>
        <v-col cols='12'>
          <v-text-field 
            v-model="economic_group_credit.comment" 
            label="Comentários"
          ></v-text-field>
        </v-col>
      </template>
      
      <!-- Modo visualização -->
      <template v-else-if="readonly && credit">
        <v-col cols='12' sm='6' md='4' class="py-0" v-if="credit.limit != null">
          <v-text-field
            :value="formatCurrency(credit.limit)"
            label="Total de Crédito (R$)" 
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols='12' sm='6' md='4' class="py-0" v-if="credit.original_limit != null">
          <v-text-field
            :value="formatCurrency(credit.original_limit)"
            label="Crédito Original (R$)" 
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols='12' sm='6' md='4' class="py-0" v-if="credit.bonus != null">
          <v-text-field
            :value="formatCurrency(credit.bonus)"
            label="Bonus (R$)" 
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols='12' sm='6' md='4' class="py-0" v-if="credit.blockingTime != null">
          <v-text-field 
            :value="credit.blockingTime"
            label="Tempo para Bloqueio" 
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols='12' class="py-0" v-if="credit.comment">
          <v-textarea 
            :rows="2"
            label="Comentários" 
            :value="credit.comment"
            readonly
          ></v-textarea>
        </v-col>
      </template>
    </v-row>
  </v-form>
</template>

<script>
import validations from '@/mixins/validations.js'
import { VMoney } from 'v-money'

export default {
  name: 'EconomicGroupCreditForm',
  mixins: [validations],
  directives: { money: VMoney },
  props: {
    credit: {
      type: Object,
      default: null,
    },
    economic_group_credit: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true
      }
    }
  },
  methods: {
    formatCurrency(value) {
      if (!value) return ''
      const numValue = typeof value === 'string' ? parseFloat(value) : value
      return numValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    validate() {
      return this.$refs.form ? this.$refs.form.validate() : true
    }
  }
}
</script>
